var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5052_3533)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5052_3533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.733 10.9413L23.471 0.78418H21.4004L13.8132 9.60349L7.75337 0.78418H0.764069L9.92773 14.1205L0.764069 24.7719H2.8348L10.847 15.4584L17.2466 24.7719H24.236L14.7325 10.9413H14.733ZM11.8969 14.238L10.9684 12.91L3.58091 2.34299H6.76143L12.7232 10.8709L13.6517 12.1989L21.4013 23.2839H18.2208L11.8969 14.2385V14.238Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5052_3533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.78418)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5052_3533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4719,
    height: 24,
    fill: "white",
    transform: "translate(0.764069 0.78418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.849a933ee44c08daf72f06f869a90372.svg";
export { ForwardRef as ReactComponent };